import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import style from './style.module.scss';

export type ReorderCardProps = {
    index?: number;
    showIndexSpacer?: boolean;
    dragHandle?: React.ReactNode;
    status?: React.ReactNode;
    meta?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    tags?: React.ReactNode;
    thumbnail?: React.ReactNode;
    thumbnailVariant?: 'croissant' | 'square';
    actions?: React.ReactNode;
    placeholder?: boolean;
    onAdd?: () => void;
    className?: string;
};

export function ReorderCard(props: ReorderCardProps) {
    const {
        index,
        showIndexSpacer,
        dragHandle,
        status,
        meta,
        title,
        subtitle,
        tags,
        thumbnail,
        thumbnailVariant = 'croissant',
        actions,
        placeholder,
        onAdd,
        className,
    } = props;

    return (
        <div className={style.row}>
            {typeof index === 'number' ? (
                <div className={style.index}>
                    {String(index + 1).padStart(2, '0')}
                </div>
            ) : showIndexSpacer ? (
                <div className={style.index} />
            ) : null}
            <div
                className={[
                    style.card,
                    placeholder ? style.placeholder : '',
                    className ?? '',
                ].join(' ')}
            >
                {placeholder ? (
                    <button
                        type="button"
                        className={style.add_button}
                        onClick={onAdd}
                    >
                        <PlusOutlined />
                    </button>
                ) : (
                    <>
                        <div className={style.header}>
                            <div className={style.header_left}>
                                {dragHandle && (
                                    <div
                                        className={`${style.drag_handle} reorder_drag_handle`}
                                    >
                                        {dragHandle}
                                    </div>
                                )}
                                {status}
                            </div>
                            <div className={style.header_right}>
                                {meta}
                                {actions}
                            </div>
                        </div>
                        <div className={style.divider} />
                        <div className={style.body}>
                            <div className={style.content}>
                                {title && (
                                    <div className={style.title}>{title}</div>
                                )}
                                {subtitle && (
                                    <div className={style.subtitle}>
                                        {subtitle}
                                    </div>
                                )}
                                {tags && (
                                    <div className={style.body_tags}>
                                        {tags}
                                    </div>
                                )}
                            </div>
                            {thumbnail && (
                                <div
                                    className={[
                                        style.thumbnail,
                                        thumbnailVariant === 'croissant'
                                            ? style.thumbnail_croissant
                                            : style.thumbnail_square,
                                    ].join(' ')}
                                >
                                    <div className={style.thumbnail_inner}>
                                        {thumbnail}
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
